import { render, staticRenderFns } from "./ASimpleDatepicker.vue?vue&type=template&id=4ed89e3b"
import script from "./ASimpleDatepicker.vue?vue&type=script&lang=js"
export * from "./ASimpleDatepicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports